import React from 'react'

const Header = () => {
    return (
        <div className="ui fixed menu">
            <div className="ui container center">
                <h1>Contact Manager</h1>
            </div>
        </div>
    )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js